const CHANNEL_MERCHANT_DEFAULT_CHANNELS = ['Booking.com', 'Airbnb', 'Expedia']

export function isChannelMerchantDefault(channel) {
  return CHANNEL_MERCHANT_DEFAULT_CHANNELS.includes(channel)
}

export const downloadFile = (data, fileName, blobOptions = {}) => {
  const blob = new Blob([data], blobOptions)
  const fileURL = window.URL.createObjectURL(blob)
  const fileLink = document.createElement('a')
  fileLink.href = fileURL
  fileLink.setAttribute('download', fileName)
  document.body.appendChild(fileLink)
  fileLink.click()
}
